import { Button } from '@salesforce/design-system-react';
import React, { useState, useContext } from 'react';
import { apiForgotPassword } from '../../services/auth';
import QFG_login from '../../assets/images/login/QFG_login.png';
import QFG_login_white from '../../assets/images/login/login_white.png';
import './login.css';
import toast, { Toaster } from 'react-hot-toast';
import { ThemeContext } from '../../context/ThemeContext';
import { Link } from 'react-router-dom';

const ForgotPasswordLeft = () => {
  const [email, setEmail] = useState(false);
  const [loading, setLoading] = useState(false);
  const { isDarkTheme } = useContext(ThemeContext);

  const onFormSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    setLoading(false);
    const result = await apiForgotPassword({email});

    if (result.data.success) {
      toast.success(result.data.message, {
        id: 'forgot-password-success-toast',
      });
    } else {
      toast.error(result.data.message, {
        id: 'forgot-password-error-toast',
      });
    }
  };

  return (
    <React.Fragment>
      <div
        className="slds-col slds-size_1-of-1 slds-large-size_6-of-12"
        style={{
          display: 'flex',
          backgroundImage: 'linear-gradient(180deg, #367bd6 0%, #71adec 100%)',
        }}
      >
        <Toaster position="top-right" reverseOrder={false} />
        <div className="custom_slds_bkg_left">
          <div className="custom_slds_bkg_left_login">
            <div>
              <img
                style={{
                  display: 'block',
                  margin: 'auto',
                  height: '118px',
                  marginBottom: '30px',
                }}
                src={isDarkTheme ? QFG_login_white : QFG_login}
                alt="qfg_login"
              />
            </div>
            <form onSubmit={onFormSubmit}>
              {/* ---------------------------form--------------------------------- */}
              <div className="slds-form-element custom_slds_bkg_left_login_child">
                {/* --------------Email---------------------- */}
                <label className="slds-form-element__label" htmlFor="form-element-01">
                  Email
                </label>
                <div className="slds-form-element__control custom_slds-form-element__control slds-m-bottom_xx-small">
                  <input
                    type="email"
                    id="login_email"
                    placeholder="Email"
                    className="slds-input"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>

                {/* ------------------Send email Button--------------- */}
                <div className="slds-x-large-buttons_horizontal mt-35">
                  <Button
                    style={{
                      width: '100%',
                      backgroundColor: '#0070D2',
                      color: '#fff',
                    }}
                    type="submit"
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        onFormSubmit(event);
                      }
                    }}
                    disabled={loading}
                  >
                    {loading ? <>Loading..</> : <>Send Email</>}
                  </Button>
                </div>
                <br />
                <div style={{ margin: 'auto 0px' }}>
                  Back to <Link to="/login"> Sign in </Link>
                </div>
              </div>
            </form>
            <div className="custom_slds_bkg_left_footer">
              {' '}
              <span>2022 Quant Ltd, All rights reserved</span> |{' '}
              <span style={{ color: '#0070D2' }}>Conditions</span>{' '}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ForgotPasswordLeft;
